import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';

export function EeLoadingArea(props: any) {
  return (
    <Backdrop
      open
      style={{
        position: props.position ? props.position : 'relative',
        zIndex: 1,
        backgroundColor: '#ebeff3',
        ...props.style,
      }}
    >
      <CircularProgress
        style={{
          color: '#f6ba07',
          width: 54,
          height: 54,
          boxShadow: 'inset 0 0 0 4px #d7dde6',
          borderRadius: '50%',
        }}
      />
    </Backdrop>
  );
}
